/**
 * Settings Modal for VariationFullImageSubtitle
 * Migrated to use shared SettingsModal pattern
 * Before: 162 lines | After: ~45 lines
 */
import { FC } from 'react';

import { ImageData } from '../VariationOne';
import { TEXT_POSITIONS } from '../VariationOne/SettingsModal';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

interface Props {
  image: ImageData;
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  multipleVariations?: boolean;
}

const SettingsModal: FC<Props> = ({ multipleVariations, image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={withWatermarkDefaults(image)}
    title="Image Parameters"
    sections={[
      {
        title: 'Text Position',
        type: 'radio',
        stateKey: 'textPosition',
        options: TEXT_POSITIONS,
      },
      ...WATERMARK_SECTIONS,
      {
        title: 'Text Parameters',
        type: 'checkbox',
        stateKey: '',
        checkboxes: [
          { key: 'quotes', label: 'Quotes' },
          { key: 'brakes', label: 'Custom brakes' },
        ],
        show: multipleVariations,
      },
    ]}
  />
);

export default SettingsModal;
